export const NAV_ITEMS = [
  { href: '/#accueil', label: 'Accueil' },
  { href: '/#seance', label: 'Votre S\u00e9ance' },
  { href: '/#a-propos', label: '\u00c0 propos' },
  { href: '/#methode', label: 'Ma M\u00e9thode' },
  { href: '/#consultations', label: 'Consultations' },
  { href: '/#contact', label: 'Contact' },
];
